
/* eslint-disable */
import { ScheduleInfo, ScheduleItem } from '@/utils/models';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

interface ScheduleItemVM extends ScheduleItem {
  startDate: Date;
  endDate: Date;
  endHour: number;
  positions: {
    top: string;
    height: string;
    left: string;
    width: string;
  };
}

@Component({ components: {} })
export default class UserScheduleDisplayer extends Vue {
  @Prop() scheduleInfo!: ScheduleInfo;
  items: ScheduleItemVM[] = [];
  today: string = '';
  isDayTime = false;
  currentTimeTop = 0;
  private timer: any = 0;
  @Watch('scheduleInfo')
  private updateItems() {
    const parentWidth = 200;
    const itemHeight = 32;

    this.items = this.scheduleInfo.scheduleItems
      .filter((v) => !v.isAllDay && !v.isCancelled && v.status !== 'free')
      .map((v) => {
        const startDate =
          typeof v.start.dateTime === 'string'
            ? new Date(new Date(v.start.dateTime).getTime() + 9 * 3600 * 1000)
            : v.start.dateTime;
        const endDate =
          typeof v.end.dateTime === 'string'
            ? new Date(new Date(v.end.dateTime).getTime() + 9 * 3600 * 1000)
            : v.end.dateTime;
        let start = Math.max(0, startDate.getHours() + startDate.getMinutes() / 60 - 8);
        let endHour = Math.max(0, endDate.getHours() + endDate.getMinutes() / 60 - 8);
        let height = Math.floor((endHour - start) * itemHeight) - 4;

        let top = Math.max(0, Math.ceil(start * itemHeight + 2));
        return {
          ...v,
          startDate,
          endDate,
          endHour,
          positions: { left: 35 + 'px', toppx: top, top: top + 'px', height: height + 'px', width: parentWidth + 'px' },
        };
      })
      .filter((v) => v.endHour > 0);
    this.items.sort((a, b) => a.startDate.getTime() - b.startDate.getTime());
    const timelines: ScheduleItemVM[][] = [];
    for (let i = 0; i < this.items.length; i++) {
      let c = this.items[i];
      let timeline = timelines.find(
        (t) => t.length === 0 || !t.find((tm) => tm.endDate > c.startDate && tm.startDate < c.endDate),
      );
      if (!timeline) {
        timeline = [];
        timelines.push(timeline);
      }
      timeline.push(c);
    }
    timelines.forEach((tl, i) => {
      tl.forEach((c) => {
        let targetIndex = i;
        for (let j = timelines.length - 1; j > i; j--) {
          const timeline = timelines[j];
          if (timeline.find((tm) => tm.endDate > c.startDate && tm.startDate < c.endDate)) {
            targetIndex = j;
            break;
          }
        }
        // j まであるのでそのサイズにspl
        const ti = targetIndex + 1;
        let width = Math.ceil(parentWidth / ti);
        c.positions.width = width - 1 + 'px';
        c.positions.left = width * i + 35 + 'px';
      });
    });
  }

  mounted() {
    this.updateItems();
    this.updateTime();
    this.timer = setInterval(() => this.updateTime(), 60 * 1000);
  }
  beforeDestroy() {
    clearInterval(this.timer);
  }
  private updateTime() {
    const today = new Date();
    const week = ['日', '月', '火', '水', '木', '金', '土'];
    this.today = `${today.getFullYear()}年${today.getMonth() + 1}月${today.getDate()}日 (${week[today.getDay()]})`;
    const currentHours = today.getHours();
    const currentMin = today.getMinutes();
    this.isDayTime = currentHours > 8 && currentHours < 20;
    if (this.isDayTime) {
      const itemHeight = 32;
      const maxHours = 12;
      let height = itemHeight * maxHours;
      let mins = currentHours * 60 + currentMin - 8 * 60; // 7時からなので。
      let top = Math.round((height * mins) / 12 / 60);
      this.currentTimeTop = top;
    }
  }
}
